import React from "react";
import { Card, CardBody } from "reactstrap";

const KpiCard = ({ title = "", value = 0, icon = "", bg = "", trend = 0 }) => {

    const trendVal = Number(trend) || 0;

    return (
        <Card className={`kpi-card ${bg}`}>
            <CardBody>
                <div className="kpi-top">
                    <div className="kpi-icon">{icon}</div>
                    <span className={`kpi-trend ${trendVal >= 0 ? "up" : "down"}`}>
                        {trendVal >= 0 ? `+${trendVal}%` : `${trendVal}%`}
                    </span>
                </div>
                <p className="kpi-title">{title || '-'}</p>
                <h4 className="kpi-value">{value || '-'}</h4>
            </CardBody>
        </Card>
    );
};

export default KpiCard;
